import { Point } from "../gateway/Point/Point";

export class RemoveManyPointUsecase {
    constructor() {
        this.PointGateway = new Point();
    }

    async execute({
        companyId = "",
        sources = [],
        times = [],
        all = false
    } = {}) {
        const payload = this.sanitizeInput({ companyId, sources, times, all });
        if (
            !payload.companyId ||
            !payload.sources.length ||
            !payload.times.length
        )
            return false;
        const response = await this.PointGateway.removeMany(payload);
        return response;
    }

    sanitizeInput({
        companyId = "",
        sources = [],
        times = [],
        all = false
    } = {}) {
        const sanitizedCompanyId = String(companyId).trim();
        const sanitizedSources = Array.isArray(sources)
            ? sources.map((source) => String(source).trim()).filter(Boolean)
            : [];
        const sanitizedTimes = Array.isArray(times)
            ? times.filter(Boolean)
            : [];
        return {
            companyId: sanitizedCompanyId,
            sources: sanitizedSources,
            times: sanitizedTimes,
            all: Boolean(all)
        };
    }
}
